import { useState } from "react";

export default function RightSidebar() {

    return (
        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-3 mobile-mt-24">
            <div className="styles_checkout_sticky__598hV">
                <div className="MuiPaper-root styles_root__UKeJN MuiPaper-elevation0 MuiPaper-rounded">

                    <div className="styles_d_flex__gMFmz">
                        <div className="styles_checkout_label_bold__KZdZj">Thông tin đơn hàng</div>

                        <div className="styles_checkout_content__5fBwM">
                            <button
                                className="MuiButtonBase-root MuiButton-root MuiButton-outlined sc-2362e412-0 sc-2362e412-2 iQEreR egmplk styles_btn__bDJ05"
                                type="button"
                                title="Sửa đơn hàng"
                            >
                                <span className="MuiButton-label">Sửa</span>
                            </button>
                        </div>
                    </div>

                    <div className="styles_d_flex__gMFmz">
                        <div className="styles_checkout_label__86Gzy">Tổng số lượng</div>
                        <div className="styles_checkout_content__5fBwM">3 sản phẩm</div>
                    </div>

                    <div className="styles_d_flex__gMFmz">
                        <div className="styles_checkout_label__86Gzy">Tổng tiền hàng</div>
                        <div className="styles_checkout_content__5fBwM">62.918.000đ</div>
                    </div>

                    <hr className="MuiDivider-root styles_dividerCustom__BK2Vd" style={{ marginBottom: 16 }} />

                    {/* Shipping fee */}
                    <div className="styles_boxDiscountSection__82B_y">
                        <div className="styles_d_flex__gMFmz" style={{ padding: 0 }}>
                            <div className="styles_checkout_label__86Gzy">Phí vận chuyển</div>
                            <div className="styles_checkout_content__5fBwM">0đ</div>
                        </div>
                    </div>

                    {/* Service fee */}
                    <div className="styles_boxDiscountSection__82B_y">
                        <div className="styles_d_flex__gMFmz" style={{ padding: 0 }}>
                            <div className="styles_checkout_label__86Gzy">Phí tiện ích</div>
                            <div className="styles_checkout_content__5fBwM">0đ</div>
                        </div>
                        <div className="styles_checkout_label_second__JJWqI">
                            Phí 0đ giao dịch
                        </div>
                    </div>

                    {/* Discount */}
                    <div className="styles_boxDiscountSection__82B_y">
                        <div className="styles_d_flex__gMFmz" style={{ padding: 0 }}>
                            <div className="styles_checkout_label__86Gzy">Tổng ưu đãi</div>
                            <div className="styles_checkout_content__5fBwM">-2.006.200đ</div>
                        </div>

                        <div className="styles_boxSubDataSection__F1mot">
                            <div className="styles_checkout_label_subdata__n7qjo">Mã SANOFI_112...</div>
                            <div className="styles_checkout_value_subdata__zF1RA">-1.686.300đ</div>
                        </div>

                        <div className="styles_boxSubDataSection__F1mot">
                            <div className="styles_checkout_label_subdata__n7qjo">Mã CHUYENKHOA...</div>
                            <div className="styles_checkout_value_subdata__zF1RA">-314.600đ</div>
                        </div>

                        <div className="styles_boxSubDataSection__F1mot">
                            <div className="styles_checkout_label_subdata__n7qjo">Mã DDMEDX-DEC...</div>
                            <div className="styles_checkout_value_subdata__zF1RA">-5.300đ</div>
                        </div>
                    </div>

                    <hr className="MuiDivider-root styles_dividerCustom__BK2Vd" />

                    {/* Total price */}
                    <div className="styles_d_flex__gMFmz styles_totalPrice__BFKN0">
                        <div className="styles_checkout_label_bold__KZdZj" style={{ fontSize: 16 }}>
                            Tổng tiền
                        </div>
                        <div className="styles_total__I_U2S">60.911.800đ</div>
                    </div>

                    <hr className="MuiDivider-root styles_dividerCustom__BK2Vd" />

                    {/* Agreement */}
                    <div>
                        <div className="styles_condition__1HFqu">
                            <label className="MuiFormControlLabel-root styles_formControlLabel__9jzcQ">
                                <span className="MuiButtonBase-root MuiIconButton-root jss1 MuiCheckbox-root styles_checkbox__j3W3G jss2 Mui-checked">
                                    <span className="MuiIconButton-label">
                                        <input
                                            className="jss4"
                                            name="checked"
                                            type="checkbox"
                                            defaultChecked
                                        />
                                        <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                        </svg>
                                    </span>
                                </span>

                                <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                                    <div className="styles_labelConfirm__SnOWJ" style={{ display: "inline-flex" }}>
                                        <div className="styles_agreement__Lj28J">Tôi đồng ý với&nbsp;</div>
                                        <a
                                            className="styles_mobile_rootBase__8z7PQ styles_check_agree_txt__jgV_U"
                                            href="/terms-and-condition"
                                            target="_blank"
                                        >
                                            <span style={{ color: "rgb(14,25,131)", textDecoration: "underline", fontSize: 14 }}>
                                                Điều khoản sử dụng
                                            </span>
                                        </a>
                                    </div>
                                </span>
                            </label>

                            <div className="styles_list_note__XUq_P">
                                <p>1. Buymed được phép hủy đơn của bạn nếu giá thị trường biến động lớn hơn 5% giá trị đơn hàng.</p>
                                <p>2. Số lượng sản phẩm khi giao có thể không đảm bảo đúng nhu cầu ban đầu tùy thuộc vào nhà cung cấp.</p>
                            </div>
                        </div>
                    </div>

                    {/* Order button */}
                    <div className="hidden-1199" style={{ display: "inline-flex", maxHeight: 40, padding: "0 16px", color: "#000", width: "100%" }}>
                        <div
                            id="delivery__info_checkout"
                            className="styles_wrapperGuide__w7nVA"
                            title="Vui lòng đồng ý với điều khoản sử dụng trước khi thanh toán"
                        >
                            <button
                                className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 sc-2362e412-2 iQEreR egmplk payment_button styles_continue_btn__kSr4K"
                                type="button"
                            >
                                <span className="MuiButton-label">Đặt hàng</span>
                            </button>
                        </div>
                    </div>

                    <div className="styles_text_right__6Z7cA" />

                </div>
            </div>

            {/* mobile hien thi */}
            <div className="styles_sticky_checkout_bar_mobile__Jv0cq show-1199">
                <div className="styles_fwc_container__XUhdT">

                    <div className="styles_flex_price__Fq0ej">
                        <div style={{ textAlign: "right" }}>
                            <div>
                                <span className="MuiTypography-root styles_footerTotalPrice__P5gGa MuiTypography-body2">
                                    Tổng tiền: <span>60.911.800đ</span>
                                </span>
                            </div>

                            <div>
                                <span className="MuiTypography-root styles_footerTotalDiscount__mLQqT MuiTypography-body2">
                                    Tổng giảm giá: <span>2.006.200đ</span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button
                            className="MuiButtonBase-root MuiButton-root styles_root_btn__BAofc MuiButton-text"
                            type="button"
                        >
                            <span className="MuiButton-label styles_label__n2CVj">
                                Đặt hàng
                            </span>
                        </button>
                    </div>

                </div>
            </div>
        </div>

    );
}
